export function areUrlPartsChanged(url1: string, url2: string): boolean {
  const parsedUrl1: URL = new URL(url1, 'https://noda.live/');
  const parsedUrl2: URL = new URL(url2, 'https://noda.live/');

  parsedUrl1.searchParams.delete('cart');
  parsedUrl2.searchParams.delete('cart');

  return parsedUrl1.pathname === parsedUrl2.pathname && parsedUrl1.search === parsedUrl2.search;
}
